import type { FaireProductEntity } from "../../entity_types/product";

export const p_pc65d4q9dk: FaireProductEntity = {
  token: "p_pc65d4q9dk",
  type: "product",
  name: "SleepBlend™",
  brandToken: "b_ai9roe1n9e",
  brandName: "Vitanica",
  imageUrl:
    "https://cdn.faire.com/fastly/bc15b78bfa81001f71eb19e6ce8b56c66b925a9b3493a48e2da939fb36227337.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6e6879f9158e508da3b72432f7c8ba7ce1ce96f277ecd5ef846b6fb49cef7efe.png",
    "https://cdn.faire.com/fastly/83b47394e65c952714aea68f26c76b86006cdddab6fa7c6df4447b12dc5f9a6e.png",
    "https://cdn.faire.com/fastly/51efcfbaa2de13ccb001ceb3bfac7f7eb30249c6a26ee4017b2b51c5b594a0a6.jpeg",
    "https://cdn.faire.com/fastly/94f39e6da6538f13d5f00b6b2a796e34ffbf88cecdb1e6b775bec10e61580fdd.jpeg",
    "https://cdn.faire.com/fastly/bfaeef31abac62ecf5582c2e3fce802d75ccaa382b0a8075ad0e48a9f342347f.jpeg",
  ],
  priceDollars: 12.95,
  description:
    "SleepBlend™ is a well-rounded product that was developed to support all aspects of sleep – falling asleep, frequent waking, waking prematurely. Utilizing scientific research, clinical experience and traditional herbal medicine it promotes balanced biorhythms in a non-addictive, safe and effective formula.*\n\n* These statements have not been evaluated by the FDA. This product is not intended to diagnose, treat, cure or prevent any disease.",
  tags: [],
  msrpDollars: 23.75,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:38.996Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
